import { render, staticRenderFns } from "./BrightStorePerformance.vue?vue&type=template&id=d60b7a4c"
import script from "./BrightStorePerformance.vue?vue&type=script&lang=js"
export * from "./BrightStorePerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports